import Vue from 'vue'
import Vuex from 'vuex'

import { auth } from './staticModules/auth.module'
import { buildModule } from '../api/dynamicRestApi'
Vue.use(Vuex)

export const store = new Vuex.Store({
	modules: {
		auth: auth,
		customers: buildModule(['customer']),
		users: buildModule(['user']),
		customerUsers: buildModule(['customer', 'user']),
		userNotifications: buildModule(['user', 'notification']),
		productionRequests: buildModule(['productionrequest']),
		customerProductionOffers: buildModule(['customer', 'productionoffer']),
		customerProductionRequests: buildModule(['customer', 'productionrequest']),
		productionOfferFiles: buildModule(['productionoffer', 'file']),
		productionRequestMaterials: buildModule(['productionrequest', 'material']),
		productionRequestTechnologys: buildModule(['productionrequest', 'technology']),
		productionRequestProductionOffers: buildModule(['productionrequest', 'productionoffer']),
		productionRequestFiles: buildModule(['productionrequest', 'file']),
		materials: buildModule(['material']),
		materialGroups: buildModule(['materialgroup']),
		technologys: buildModule(['technology']),
		technologyGroups: buildModule(['technologygroup']),
		files: buildModule(['file'])
	}
})
